import MailSearchStore from './schema/MailSearchStore';
import { createStore } from 'satcheljs';
import { getDefaultAdvancedSearchViewState } from './schema/AdvancedSearchViewState';

export const defaultMailSearchStore: MailSearchStore = {
    advancedSearchViewState: getDefaultAdvancedSearchViewState(),
    fromDate: null,
    includeAttachments: false,
    initialAdvancedSearchViewState: getDefaultAdvancedSearchViewState(),
    initialSearchScope: null,
    isAdvancedSearchVisible: false,
    isFolderScopeVisible: false,
    isSearchHistoryDirty: false,
    previousNode: null,
    searchNumber: 0,
    staticSearchScope: null,
    staticSearchScopeList: null,
    toDate: null,
    answer: null,
};

const initialStore = { ...defaultMailSearchStore };
export const getStore = createStore<MailSearchStore>('mailSearchStoreNext', initialStore);

const store = getStore();
export default store;
